import React, {useEffect, useState} from "react";
import {Menu, Tooltip, Button} from "antd";
import _ from "lodash";
import {Link} from "react-router-dom";
import {useLocation} from "react-router";
import dayjs from "dayjs";
import AppContext from "../../application/AppContext";
import Payment from "../../asset/image/Payment.png";

function ExpireInfo() {
    const getColor = (date) => {
        if (dayjs().isAfter(dayjs(date).subtract(1, "month"))) {
            return "#F85853";
        } else if (dayjs().isAfter(dayjs(date).subtract(2, "month"))) {
            return "#FF8B00";
        } else {
            return "#90A4AD";
        }
    };

    return (
        <div
            style={{
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
                fontSize: 12,
                flexShrink: 0,
            }}
        >
            <div style={{color: getColor(AppContext.user?.hospital?.expireDate)}}>
                到期时间：{dayjs(AppContext.user?.hospital?.expireDate).format("YYYY.MM.DD")}
            </div>
            <Tooltip
                overlayClassName="ad-button-tooltip"
                placement="top"
                forceRender
                title={(
                    <img src={Payment} />
                )}
            >
                <Button
                    type="link"
                    style={{
                        marginLeft: 4,
                        fontSize: 13,
                        height: "auto",
                        padding: 0,
                    }}
                >
                    立即续费
                </Button>
            </Tooltip>
        </div>
    );
}

const renderMenus = (menus, baseUrl = "") => {
    return _.map(menus, (it) => {
        const path = `${baseUrl}/${it.key}`;

        if (!_.isEmpty(it.children)) {
            return (
                <Menu.SubMenu
                    key={it.key}
                    title={(
                        <div style={{display: "flex", alignItems: "center"}}>
                            {
                                it.icon != null
                                    ? (<span style={{display: "flex", alignItems: "center", marginRight: 8, flex: "none"}}>{it.icon}</span>)
                                    : null
                            }
                            <span style={{fontSize: 15, flex: "none"}}>{it.name}</span>
                        </div>
                    )}
                >
                    {renderMenus(it.children, path)}
                </Menu.SubMenu>
            );
        } else {
            return (
                <Menu.Item key={path} style={{fontSize: 15}}>
                    <Link to={path}>
                        <div style={{display: "flex", alignItems: "center"}}>
                            {
                                it.icon != null
                                    ? (<span style={{display: "flex", alignItems: "center", marginRight: 8, flex: "none"}}>{it.icon}</span>)
                                    : null
                            }
                            <span style={{flex: "none"}}>{it.name}</span>
                        </div>
                    </Link>
                </Menu.Item>
            );
        }
    });
};


const RouteMenu = (props) => {
    const {routes, top, width} = props;
    const location = useLocation();
    const [openKeys, setOpenKeys] = useState([]);
    const [selectedKey, setSelectedKey] = useState();

    const setOpenAndSelectKeys = () => {
        const paths = location.pathname.split("/");

        setOpenKeys((current) => {
            return _.chain(current)
                .concat(_.drop(paths))
                .uniq()
                .value();
        });
        setSelectedKey(location.pathname);
    };

    useEffect(() => {
        setOpenAndSelectKeys();
    }, [location.pathname]);

    return (
        <div
            style={{
                display: "flex",
                flexDirection: "column",
                overflow: "auto",
                width,
                padding: "0 6px 20px",
                backgroundColor: "#FFF",
                position: "fixed",
                left: 0,
                bottom: 0,
                top,
            }}
        >
            <div
                style={{
                    flex: 1,
                    overflowY: "auto",
                    overflowX: "hidden",
                    display: "flex",
                }}
            >
                <Menu
                    {...props}
                    inlineIndent={20}
                    className="renyuan-menu"
                    width={null}
                />

            </div>
            {
                !__IS_INHOS__ && (
                <ExpireInfo />
                )
            }
        </div>
    );
};


export default React.memo(RouteMenu);
